import { render } from "./ContactInfos.vue?vue&type=template&id=17dba1ef"
import script from "./ContactInfos.vue?vue&type=script&lang=ts"
export * from "./ContactInfos.vue?vue&type=script&lang=ts"
script.render = render

export default script